import { mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';

import { noop } from 'ui-components/default-props/noop';
import { ModalService } from 'ui-components/services/modal-service';

import { ManageTagsModalContainer } from '../../containers/manage-tags-modal-container';
import * as TagsApi from '../../store/tags/tags.api';
import { bulkloadFulfillmentPlans } from '../bulkload/bulkload.actions';
import * as Actions from './tags.actions';

export const openManageTagsModal = (action$) => {
  return action$.pipe(
    ofType(Actions.MANAGE_TAGS),
    mergeMap(() => {
      ModalService.launchModal({
        component: ManageTagsModalContainer,
      });
      return EMPTY;
    }),
  );
};

export const bulkAddFulfillmentPlanTags = (action$) =>
  action$.pipe(
    ofType(Actions.FULFILLMENT_PLANS_BULK_ADD_TAGS_REQUEST),
    mergeMap((action) => {
      const { fulfillmentPlanIds, tagIds, errorCallback = noop } = action;
      return TagsApi.bulkAddFulfillmentPlanTags({
        fulfillmentPlanIds,
        tagIds,
      }).pipe(
        mergeMap(() => {
          return of(bulkloadFulfillmentPlans(fulfillmentPlanIds));
        }),
        catchError(() => {
          errorCallback(action);
          return of(bulkloadFulfillmentPlans(fulfillmentPlanIds));
        }),
      );
    }),
  );

export const bulkRemoveFulfillmentPlanTags = (action$) =>
  action$.pipe(
    ofType(Actions.FULFILLMENT_PLANS_BULK_REMOVE_TAGS_REQUEST),
    mergeMap((action) => {
      const { fulfillmentPlanIds, tagIds, errorCallback = noop } = action;
      return TagsApi.bulkRemoveFulfillmentPlanTags({
        fulfillmentPlanIds,
        tagIds,
      }).pipe(
        mergeMap(() => {
          return of(bulkloadFulfillmentPlans(fulfillmentPlanIds));
        }),
        catchError(() => {
          errorCallback(action);
          return of(bulkloadFulfillmentPlans(fulfillmentPlanIds));
        }),
      );
    }),
  );
